import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

// CAESAR – Beállítások. Itt kapcsolható a HIBRID (helyi mappás) mód: a tényleges ügykezelés a
// lemezen lévő mappákban van, a program csak beolvassa és számozza az ügyeket (read-only). Az
// ügytípusonkénti gyökérmappát az Ügytípusok menüben kell megadni; itt a kapcsoló, a közös JÜB
// mappa, az ügy-szinkron és a JÜB-ellenőrzés/force-sync található.
@Component({
  selector: 'app-caesar-beallitasok',
  templateUrl: './beallitasok.component.html',
  styleUrls: ['./beallitasok.component.scss'],
})
export class BeallitasokComponent implements OnInit {
  intezmeny = '';
  standalone = false;       // helyi (Electron) példány-e – csak ott működik a hibrid mód
  desktop = !!(window as any).cronom?.desktop;  // natív mappaválasztó elérhető-e
  aktiv = false;
  jubMappa = '';
  mentes = false;

  syncFut = false;
  syncEredmeny: any = null;

  jubStatusz: any = null;   // { mappa, fajlok:[{fajlnev, allapot, ...}], hiba? }
  jubFut = false;

  constructor(private http: HttpClient, private data: DataService, private toast: ToastController, private alert: AlertController) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = si?.intezmenyId || '';
    await this.betolt();
  }

  async betolt() {
    try {
      const r: any = await firstValueFrom(this.http.get('/api/caesar/hibrid/beallitas/' + this.intezmeny));
      this.standalone = !!r.standalone;
      this.aktiv = !!r.aktiv;
      this.jubMappa = r.jub_mappa || '';
    } catch { this.hiba('Nem sikerült betölteni a beállításokat.'); }
    if (this.standalone && this.aktiv) await this.jubEllenoriz();
  }

  async tallozJub() {
    const pf = (window as any).cronom?.pickFolder;
    if (!pf) return;
    const p = await pf({ title: 'Közös JÜB mappa', defaultPath: this.jubMappa || undefined });
    if (p) this.jubMappa = p;
  }

  async ment() {
    this.mentes = true;
    try {
      await firstValueFrom(this.http.put('/api/caesar/hibrid/beallitas/' + this.intezmeny, { aktiv: this.aktiv, jub_mappa: this.jubMappa.trim() }));
      this.ok('Beállítások mentve.');
      if (this.aktiv) await this.jubEllenoriz();
    } catch { this.hiba('Nem sikerült menteni.'); }
    finally { this.mentes = false; }
  }

  // Ügyek beolvasása a helyi mappákból (read-only). Az ügytípusokhoz rendelt mappákat dolgozza fel.
  async ugySync() {
    this.syncFut = true; this.syncEredmeny = null;
    try {
      const r: any = await firstValueFrom(this.http.post('/api/caesar/hibrid/sync/' + this.intezmeny, {}));
      this.syncEredmeny = r;
      this.ok(`Szinkron kész: ${r.letrehozott} új ügy, ${r.meglevo} meglévő.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült szinkronizálni az ügyeket.'); }
    finally { this.syncFut = false; }
  }

  async jubEllenoriz() {
    try {
      this.jubStatusz = await firstValueFrom(this.http.get('/api/caesar/hibrid/jub-statusz/' + this.intezmeny));
    } catch { this.jubStatusz = null; }
  }

  async jubSync(force = false) {
    this.jubFut = true;
    try {
      const r: any = await firstValueFrom(this.http.post('/api/caesar/hibrid/jub-sync/' + this.intezmeny + (force ? '?force=1' : ''), {}));
      const ujak = (r.eredmeny || []).filter((x: any) => !x.kihagyva && !x.hiba).length;
      const hibak = (r.eredmeny || []).filter((x: any) => x.hiba).length;
      this.ok(`JÜB szinkron: ${ujak} feldolgozva${hibak ? `, ${hibak} hiba` : ''}.`);
      await this.jubEllenoriz();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült szinkronizálni a JÜB mappát.'); }
    finally { this.jubFut = false; }
  }

  jubSzin(a: string) { return { uj: 'primary', valtozott: 'warning', importalva: 'success', hiba: 'danger' }[a] || 'medium'; }
  jubCimke(a: string) { return { uj: 'új', valtozott: 'változott', importalva: 'importálva', hiba: 'hiba' }[a] || a; }
  get jubUjDb() { return (this.jubStatusz?.fajlok || []).filter((f: any) => f.allapot === 'uj' || f.allapot === 'valtozott').length; }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2200, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 3000, color: 'danger' })).present(); }
}
